import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km3};
  overflow: hidden;

  a {
    color: ${({ theme }) => theme.color.text.neutral.default};
  }
`;

export const PhoneContainer = styled.div<{ isActive?: boolean }>`
  ${({ theme, isActive }) => css`
    align-items: center;
    border-radius: ${theme.border.radius.medium};
    border: ${theme.border.width.thinner} ${theme.border.style.solid} ${theme.color.icon.neutral.weak};
    display: flex;
    justify-content: space-between;
    padding: ${theme.spacing.km3} ${theme.spacing.km2};

    fuel-typography {
      padding-left: ${theme.spacing.km3};
    }

    @media screen and (max-width: ${theme.breakpoint.md.maxWidth}) {
      border: none;
      border-radius: ${theme.border.radius.large};
      display: flex;
      gap: ${theme.spacing.km3};
      height: 44px;
      margin: ${theme.spacing.km1};
      justify-content: flex-start;
      padding: ${theme.spacing.km3} ${theme.spacing.km4};
      background-color: ${isActive ? theme.color.background.neutral.weak : 'transparent'};
    }
  `}
`;
